export const MIGRATIONS_ALLOWED_HOSTS = ['perm.alivewater.online'] as const;

/** Миграция доступна только в PostgreSQL-контуре Perm Cloud, но не в AWS. */
export function isMigrationsHost(hostname = window.location.hostname): boolean {
  return MIGRATIONS_ALLOWED_HOSTS.some((host) => host === hostname);
}
